import api from "../Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};



// ✅ Get Categories List (Admin)
export const getCategoriesList = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
  };

  try {
    const response = await api.get("/admin/get-categories-list", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
        ...params, // ✅ لو عايز تبعت params إضافية مستقبلاً
      },
    });

    return response.data; // { data: [...], message: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Add Category (Admin)
export const addCategory = async ({
  name,
  name_en,
  description,
  description_en,
  image,
  status = 1,
}) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
  };

  const formData = new FormData();

  formData.append("name", String(name || ""));
  formData.append("name_en", String(name_en || ""));
  formData.append("description", String(description || ""));
  formData.append("description_en", String(description_en || ""));
  formData.append("status", String(status));

  if (image) {
    formData.append("image", image); // لازم يكون File object
  }

  try {
    const response = await api.post("/admin/add-category", formData, {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return response.data; // { data: {...}, message: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Update Category (Admin)
export const updateCategory = async ({
  id,
  name,
  name_en,
  description,
  description_en,
  image,
  status = 1,
}) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
  };

  const formData = new FormData();

  formData.append("name", String(name || ""));
  formData.append("name_en", String(name_en || ""));
  formData.append("description", String(description || ""));
  formData.append("description_en", String(description_en || ""));
  formData.append("status", String(status));

  // الصورة اختيارية في التعديل
  if (image instanceof File) {
    formData.append("image", image);
  }

  try {
    const response = await api.post(
      `/admin/update-category/${id}`,
      formData,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return response.data; // { data: {...}, message: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Get Category Details (Admin)
export const getCategoryDetails = async (id) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
  };

  try {
    const response = await api.get(
      `/admin/get-category-details/${id}`,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return response.data; 
    // { data: { ...category, products: [...] }, message: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Get Products List (Admin)
export const getProductsList = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
  };

  try {
    const response = await api.get("/admin/get-products-list", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
        ...params, // لو حابب تضيف فلترة مستقبلاً
      },
    });

    return response.data; 
    // { data: [...products], message: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
export const getProductsDetails = async (id) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
  };

  try {
    const response = await api.get(
      `/admin/get-product-details/${id}`,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return response.data; 
    // { data: { ...category, products: [...] }, message: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Add Product (Admin) - single product
export const addProduct = async ({
  name,
  name_en,
  description,
  description_en,
  price,
  category_id,
  image,
  prepare_time,
}) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  const formData = new FormData();

  formData.append("products[0][name]", String(name || ""));
  formData.append("products[0][name_en]", String(name_en || ""));
  formData.append("products[0][description]", String(description || ""));
  formData.append("products[0][description_en]", String(description_en || ""));
  formData.append("products[0][price]", String(price || ""));
  formData.append("products[0][category_id]", String(category_id || ""));
  formData.append("products[0][prepare_time]", String(prepare_time || ""));

  if (image instanceof File) {
    formData.append("products[0][image]", image);
  }

  try {
    const res = await api.post("/admin/add-product", formData, {
      headers,
      params: { api_password: "AI_Pos_passCode2026" },
    });

    return res.data; // { data: [...], message: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Update Product (Admin)
export const updateProduct = async ({
  id,
  name,
  name_en,
  description,
  description_en,
  price,
  category_id,
  image,
  prepare_time,
  status = 1,
}) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  const formData = new FormData();

  formData.append("name", String(name || ""));
  formData.append("name_en", String(name_en || ""));
  formData.append("description", String(description || ""));
  formData.append("description_en", String(description_en || ""));
  formData.append("price", String(price || ""));
  formData.append("category_id", String(category_id || ""));
  formData.append("prepare_time", String(prepare_time || ""));
  formData.append("status", String(status));

  // الصورة اختيارية
  if (image instanceof File) {
    formData.append("image", image);
  }

  try {
    const res = await api.post(
      `/admin/update-product/${id}`,
      formData,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data; // { data: {...}, message: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};


